var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.scroll)?_c('div',{staticClass:"scroll-x"},[_c('div',{staticClass:"scroll-body"},[_vm._t("default")],2)]):_c('div',{style:({overflow: 'hidden'})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }